import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import * as fromShared from '../../../shared';
import * as fromDataServices from '../../../data-services';
import moment from 'moment';
import { ReplaySubject, combineLatest } from 'rxjs';
import { LoggingService } from '../../../shared/services/logging';
import { take, takeWhile } from 'rxjs/operators';
import { ThirdPartyPayroll } from '../../third-party/store';
@Component({
    selector: 'ef-payroll-export-presenter',
    templateUrl: './payroll-export-presenter.component.html',
    styleUrls: ['./payroll-export-presenter.component.scss'],
    standalone: false
})
export class PayrollExportPresenter
    extends fromShared.EditGrid<fromDataServices.PayrollExport.PayrollExportModel>
    implements AfterViewInit, OnChanges, OnDestroy
{
    numCols = 9;
    moment: any = moment;
    @Input() public set Payrolls(value: ThirdPartyPayroll[]) {
        this.PayrollsSubject.next(value);
    }

    PayrollsSubject = new ReplaySubject<ThirdPartyPayroll[]>(1);
    ScrollToItem =
        new ReplaySubject<fromDataServices.PayrollExport.PayrollExportModel>(1);
    @Output() View =
        new ReplaySubject<fromDataServices.PayrollExport.PayrollExportModel>(1);
    @Output() Send = new ReplaySubject<string | number>(1);
    @Output() Sync = new ReplaySubject<string | number>(1);
    @Output() Refresh = new ReplaySubject<string | number>(1);
    private active = true;
    constructor(private log: LoggingService) {
        super();
    }
    override onStatusClick(item: { id: string | number }) {
        const model = item as fromDataServices.PayrollExport.PayrollExportModel;
        if (model.Status.StatusCode !== fromShared.ResponseStatus.Success) {
            this.ShowError.emit({
                open: true,
                MsgEntityID: item.id.toString()
            });
        }
    }
    ngAfterViewInit(): void {
        this.ScrollToItem
            // .pipe(take(1))
            .subscribe(item => {
                const idx = this.items.indexOf(item);
                const id = `row-${item.id}`;
                const row = document.getElementById(id) as HTMLElement;
                this.log.verbose({
                    type: 'PayrollExportPresenter:ScrollToItem',
                    idx,
                    item,
                    row,
                    id,
                    offsetWidth: row.offsetWidth,
                    offsetHeight: row.offsetHeight,
                    getClientRects: row.getClientRects().length
                });
                if (true) {
                    this.log.verbose({
                        type: 'PayrollExportPresenter:ScrollToItem:invisible',
                        idx,
                        item,
                        row,
                        id
                    });
                    this.dataTable.scrollTo({
                        top:
                            row && row.offsetHeight
                                ? row.offsetHeight * idx
                                : 0,
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                }
                // this.dataTable.scrollToVirtualIndex(idx);
            });
        combineLatest([this.PayrollsSubject, this.View])
            .pipe(takeWhile(() => this.active))
            .subscribe(([payrolls, item]) => {
                this.log.verbose({
                    type: 'PayrollExportPresenter:View',
                    item,
                    payrolls
                });
                this.items.forEach((x: any) => (x.canView = true));
                const i = this.items.find(x => x.id === item.id) as any;
                if (i && payrolls.length > 0) i.canView = false;
            });
    }
    isVisible = elem =>
        elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length;
    ngOnDestroy(): void {
        this.active = false;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        this.log.verbose({
            type: 'PayrollExportPresenter:ngOnChanges',
            changes
        });
        if (changes && changes.items) {
            const item = this.items.find(item =>
                (Object as any)
                    .values(
                        fromDataServices.PayrollExport
                            .PayrollExportInProgressStatuses
                    )
                    .includes(item.ExportStatus)
            );
            if (item) {
                this.log.verbose({
                    type: 'PayrollExportPresenter:ngOnChanges',
                    item
                });
                setTimeout(() => {
                    this.ScrollToItem.next(item);
                }, 0);
            }
        }
    }
    StatusClick(item: fromDataServices.PayrollExport.PayrollExportModel) {
        this.log.verbose({
            type: 'PayrollExportPresenter:StatusClick',
            item
        });
        this.onStatusClick(item);
    }
}
